module.exports = __webpack_public_path__ + "img/appAsset-brand--khipuLogo.b4c3cd99.svg";